import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { PlanningDataService, PlanningApiService, PlanningFormService } from '../../../shared/services';
import { Options } from 'ng5-slider';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'risk-settings',
  templateUrl: './risk-settings.component.html',
  styleUrls: ['./risk-settings.component.css']
})
export class RiskSettingsComponent implements OnInit, OnDestroy, OnChanges {

  @Input() projection;

  currentProjection;
  testedParty;
  riskSettingsConfirmed = false;
  riskForm;

  options: Options = {
    floor: 1,
    ceil: 3,
    translate: (value: number): string => {
      switch (value) {
        case 1: return this._translateService.instant('planning.risk_settings_low');
        case 2: return this._translateService.instant('planning.risk_settings_medium');
        case 3: return this._translateService.instant('planning.risk_settings_high');
        default: return this._translateService.instant('planning.risk_settings_invalid_value');
      }
    },
    showSelectionBar: true,
    selectionBarGradient: {
      from: 'white',
      to: '#C84091'
    }
  };

  constructor(
    private _planningApiService: PlanningApiService,
    private _planningDataService: PlanningDataService,
    private _planningFormService: PlanningFormService,
    private _translateService: TranslateService
  ) { }

  ngOnInit() {
    this.currentProjection = this.projection;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.currentProjection = changes.projection.currentValue;
    this.findTestedParty();
    if (this.currentProjection) {
      this.riskForm = new FormGroup({
        aggressiveLevel: new FormControl(this.currentProjection.riskValues.aggressiveLevel || 1),
        auditHistory: new FormControl(this.currentProjection.riskValues.auditHistory || 1),
        documentationLevel: new FormControl(this.currentProjection.riskValues.documentationLevel || 1)
      });
      this.updateAllRiskValues();
    }
  }

  ngOnDestroy() {
  }

  saveForm() {
    this._planningApiService.saveScenario(this._planningDataService.getCurrentScenarioValue()).subscribe();
  }

  findTestedParty() {
    if (this.currentProjection.srcEntity.isTestedParty) {
      this.testedParty = this.currentProjection.srcEntity;
    } else if (this.currentProjection.dstEntity.isTestedParty) {
      this.testedParty = this.currentProjection.dstEntity;
    }
  }

  updateAllRiskValues() {
    this.riskSettingsConfirmed = false;
    this._planningFormService.setFormStatus('riskSettingsForm', false);
    this.updateFormValuesInProjection();

    const currentFormValues = this.riskForm.value;
    this._planningDataService.updateRiskLevels(this.currentProjection.projectionId, currentFormValues);
    this.saveForm();
  }

  confirmRiskSetting() {
    this.riskSettingsConfirmed = true;
    this._planningFormService.setFormStatus('riskSettingsForm', true);
    this.updateFormValuesInProjection();
    this.saveForm();
  }

  updateFormValuesInProjection() {
    const currentFormStatus = this._planningFormService.getCurrentFormStatus();
    this._planningDataService.updateFormValues(currentFormStatus, this.currentProjection.projectionId);
  }

}
